import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Badge } from 'rebass';
import { PvBox } from 'styles/CustomComponents';
import styled from 'styled-components';
import { formatCourseWithExamClassesCompact } from '../util/FormatUtil';

export const BadgeType = {
  ACTIVE: 'ACTIVE',
  PASSIVE: 'PASSIVE'
};

const PvBadgeElement = styled(Badge)`
  margin-left: 0;
  margin-right: 0;
  text-transform: capitalize;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSizes[1]}px;
`;

const PvBadge = ({type, i18nMessage, message, ml, color, ...props}) => {
  const badgeColor =
    (() => {
      switch (type) {
        case BadgeType.ACTIVE:
          return 'green';
        case BadgeType.PASSIVE:
          return 'berryRed';
        default:
          return 'green';
      }
    })();

  const badgeMessage = i18nMessage ||
    (() => {
      switch (type) {
        case BadgeType.ACTIVE:
          return 'applicant.active';
        case BadgeType.PASSIVE:
          return 'applicant.passive';
        default:
          return 'applicant.active';
      }
    })();

  return (
    <PvBox display='inline-block' ml={ml} mr={1} mt={1} {...props}>
      <PvBadgeElement bg={color || badgeColor}>
        {message ?  message  : <Translate value={badgeMessage} />}
      </PvBadgeElement>
    </PvBox>
  );
};

PvBadge.propTypes = {
  i18nMessage: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  showExamClasses: PropTypes.bool,
  color: PropTypes.string,
};

export const PvCourseBadge = ({ course, format=formatCourseWithExamClassesCompact, ...props }) => {
  return <PvBadge message={format(course) } {...props} />
}

PvCourseBadge.propTypes = {
  course: PropTypes.object.isRequired,
  format: PropTypes.func,
  ...PvBadge.propTypes
};

export default PvBadge;



// WEBPACK FOOTER //
// ./src/components/PvBadge.jsx